import React from "react";
import cn from "classnames";

export default function LeadingText({
  textAlign,
  textSize = "base",
  textColor,
  fontWeight = "normal",
  children
}) {
  return (
    <h3
      className={cn(
        textAlign && `text-${textAlign}`,
        textColor && `text-${textColor}`,
        `text-${textSize}`,
        `font-${fontWeight}`
      )}
    >
      {children}
    </h3>
  );
}



// WEBPACK FOOTER //
// ./src/LeadingText/LeadingText.js